<p class="alert alert-danger" role="alert" *ngIf="ErrorMessage">{{ErrorMessage}}</p>
<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">فرم پاسخ به تیکت 'شماره ی {{Ticket_Selected?.code}} '</h5>
      <p class="alert alert-warning" role="status" *ngIf="!canReply">امکان پاسخ به این تیکت وجود ندارد.</p>
      <form  >
          <div class="row">
            <div class="form-group col-md-12">
              <label for="TicketReply-component-field-1">شرح تیکت</label>
              <ckeditor id="TicketReply-component-field-1" name="editorData" [(ngModel)]="model.editorData" [config]="config" [editor]="Editor"></ckeditor>
              <small class="text-danger" role="alert" *ngIf="ValidationErrors.message">{{ValidationErrors.message}}</small>
            </div>
          </div>

          <br/>
          <br/>
          <br/>
          <br/>

          <div  class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1">
                فایل/های ضمینه ( jpeg , png , jpg , pdf )
                <button (click)="Remove_uploadImage1()"  type="button" *ngIf="UploadImageSrc"  class="btn  btn-danger" title="حذف پیوست" aria-label="حذف پیوست"><i class="fa  fa-times-rectangle"></i> </button>
              </label>
              <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
              <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file" class="form-control"  placeholder="اینجا تایپ کنید ...">
            </div>
          </div>

          <button  type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc" class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن ضمینه </button>

          <br/>
          <br/>

          <div class="table-responsive" *ngIf="UploadImageSrc_List.length>0">
            <table class="mb-0 table table-bordered table-3 text-center table-striped">
              <thead style="background-color: #489b39; color: white;">
                <tr>
                  <th>#</th>
                  <th>فایل</th>

                  <th  >امکانات</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of UploadImageSrc_List" >

                    <td>{{UploadImageSrc_List.indexOf(item)+1}}</td>
                    <td>

                      <a target="_blank" *ngIf="item.includes('.pdf')"  href="{{BaseUrl}}File/Ticket/{{item}}" class="btn btn-success" ><i class="fa fa-file-pdf-o"></i> PDF </a>


                      <img *ngIf="!item.includes('.pdf')" (click)="openModal(templateImage,item)" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Ticket/{{item}}"/>
                    </td>
                    <td >
                        <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                          <div class="btn-group" role="group">
                              <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  امکانات
                              </button>
                              <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                  <a style="cursor: pointer;" (click)="UploadImageSrc_List_Delete(UploadImageSrc_List.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> حذف </a>
                              </div>
                          </div>
                      </div>
                    </td>

                </tr>
              </tbody>
            </table>
          </div>

          <br/>
          <br/>

          <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
          <button *ngIf="!InProccessing" type="button" (click)="onSubmitForm()" [disabled]="InProccessing || InProccessing_Image1 || !canReply"  class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
          <button (click)="OnSet_Back_Ticket()" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>
      </form>
  </div>
</div>


<ng-template #templateImage>
  <div class="modal-header">
     <h4 class="modal-title pull-left"> نمایش عکس </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img  style="max-width: 100%;" src="{{BaseUrl}}File/Ticket/{{ModalimageUrl}}"/>
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Ticket/{{ModalimageUrl}}"   ><i class="fa fa-download"></i> دانلود </a>
     <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">بستن</button>
  </div>
</ng-template>
